import React from 'react';
import { StyleSheet, View } from 'react-native';
import ChildNodeRenderer from 'shared/renderer/ChildNodeRenderer/ChildNodeRenderer';
import { VXLComponent, VXLGroup } from 'shared/renderer/types';

interface ComponentSectionProps {
  childNodes: (VXLComponent | VXLGroup)[];
}

/**
 * A generic container which stacks child nodes vertically and renders them without adding additional styling.
 * Used for composing multiple child nodes together in a 'section' of the screen.
 */
const ComponentSection = ({ childNodes }: ComponentSectionProps) => {
  return (
    <View style={styles.container}>
      {childNodes.map((child) => {
        return (
          <ChildNodeRenderer
            key={`${child.name}-${child.id}`}
            toRender={child}
          />
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default ComponentSection;
